<template>
  <div class="card card-content">
    <div class="card-header">
      <div class="header">
        <div class="breadcrumb">
          <a class="breadcrumb-item" v-link="{ path: '/'}">Accueil</a>
          <a class="breadcrumb-item" v-link="{ path: '/contact/list'}">Gestion des participants</a>
          <a class="breadcrumb-item" v-link="{ name: 'editContact', params: { contactId: this.contact.id } }">{{ name }}</a>
          <a class="breadcrumb-item" v-link="{ name: 'editContact.emplois', params: { contactId: this.contact.id } }">Emplois</a>
        </div>
        <h1>{{ contact.leader_firstname }} {{ contact.leader_lastname }}</h1>
      </div>
      <div class="actions">
        <a class="btn btn-link" v-link="{ path: '/contact/list' }">Voir tous les participants</a>
        <a class="btn btn-link" v-link="{ name: 'addProjectWithContact', params: { contactId: contact.id } }">Ajouter un parcours</a>
        <a class="btn btn-link" v-link="{ name: 'addMeetingWithContact', params: { contactId: contact.id } }">Ajouter un rdv</a>
      </div>
    </div>
    <div class="card-block">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact', params: { contactId: contact.id }}">Informations</a>
        </li>
		<li class="nav-item">
          <a class="nav-link" v-link="{ name: 'parcoursContact', params: { contactId: contact.id }}">Parcours</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'planningContact', params: { contactId: contact.id }}">Planning</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.entreprises', params: { contactId: contact.id }}">Entreprises</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" v-link="{ name: 'editContact.emplois', params: { contactId: contact.id }}">Emplois</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.formations', params: { contactId: contact.id }}">Formations</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.capes', params: { contactId: contact.id }}">CAPE</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.cers', params: { contactId: contact.id }}">CER</a>
        </li>
      </ul>
    </div>
    <div class="card-block">
      <h2 class="card-title">Liste des emplois</h2>
      <table class="table table-hover">
        <thead>
        <tr>
          <th>Titre</th>
          <th>Position</th>
          <th>&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="job of jobs | orderBy 'title'">
          <td>{{ job.title }}</td>
          <td>{{ job.position }}</td>
          <td class="text-xs-right">
            <button class="btn btn-primary" v-on:click="edit(job)">Modifier</button>
            <button class="btn btn-warning" v-on:click="remove(job)">Supprimer</button>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td colspan="6">
            <button class="btn btn-primary" v-on:click="create()">Créer un emploi</button>
          </td>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>
  <div class="card-block" v-if="job !== null">
    <hr>
    <h2 class="card-title">{{ editionName }}</h2>
    <validator name="validator">
      <form novalidate>
        <div class="form-group">
          <label for="title">Titre</label>
          <input type="text" v-model="job.title" class="form-control" v-validate:title="{required: required, maxlength: 90}">
          <small class="form-text text-danger" v-if="$validator.title.required">Vous devez indiquer un nom</small>
          <small class="form-text text-danger" v-if="$validator.title.maxlength">Trop long</small>
        </div>
        <div class="form-group">
          <label for="contract_types">Type d'emploi</label>
          <div v-for="element in job.contract_types_list">
            <switch :value.sync="element.selected">{{ element.name }}</switch>
          </div>
        </div>
        <div class="form-group">
          <label for="position">Précision emploi</label>
          <input class="form-control"
            id="job_other"
            type="text"
            v-model="job.job_other" v-validate:job_other="{maxlength: 255}"
          >
          <small class="form-text text-danger" v-if="$validator.job_other.maxlength">Trop long</small>
        </div>
        <div class="form-group">
          <label for="position">Fonction</label>
          <input class="form-control"
            id="position"
            type="text"
            v-model="job.position"
          >
          <small class="form-text text-danger" v-if="$validator.position.maxlength">Trop long</small>
        </div>
        <div class="form-group">
          <label>Date de début du contrat</label>
          <!--
          <date-picker :time.sync="job.start_contract" :option="datepickerOptions"></date-picker>
          <input type="hidden" v-model="job.start_contract">
          -->
          <input
            id               = "start_contract"
            class            = "form-control"
            type             = "text"
            v-model          = "job.start_contract"
          >
        </div>
        <div class="form-group">
          <label>Date de fin du contrat</label>
          <!--
          <date-picker :time.sync="job.end_contract" :option="datepickerOptions" ></date-picker>
          <input type="hidden" v-model="job.end_contract">
          -->
          <input
            id               = "end_contract"
            class            = "form-control"
            type             = "text"
            v-model          = "job.end_contract"
       	  >
        </div>
        <div class="form-group">
          <switch :value.sync = "job.conventional_objective">Objectif conventionné</switch>
        </div>
        <div class="form-group">
          <switch :value.sync = "job.job_creation">Création du poste</switch>
        </div>
        <div class="form-group">
          <label for="observation">Observation</label>
          <textarea v-model="job.observation" id="observation" rows="10" class="form-control"></textarea>
        </div>
        <div class="text-xs-right">
          <button class="btn btn-default" v-on:click.prevent="cancel()">Fermer</button>
          <button class="btn btn-primary" v-on:click.prevent="save()" :class="{ disabled: !$validator.valid }">Enregistrer</button>
        </div>
      </form>
    </validator>
  </div>
</template>
<script>
    // Required for datepicker
    import moment from 'moment'

    // Options for datepicker
    import { datepickerOptions } from 'src/options/date'
    import { Switch } from 'mint-ui'

    // Required for datepicker
    import datePicker from 'vue-datepicker/vue-datepicker-1.vue'

    // Vuex
    import { getJobs, addJob, editJob, deleteJob } from 'src/vuex/actions/jobActions'
    import { getContact } from 'src/vuex/actions/contactActions'
    import { getContractTypes } from 'src/vuex/actions/contractTypesActions'

    import { contact, contractTypes, jobs, jobsRequestError as requestError } from 'src/vuex/getters'

    export default {
      vuex: {
        getters: {
          jobs,
          requestError,
          contact,
          contractTypes
        },
        actions: {
          getContact,
          getJobs,
          addJob,
          editJob,
          deleteJob,
          getContractTypes
        }
      },
      data () {
        return {
          isHidden: true,
          job: null,
          jobUpdate: null,
          datepickerOptions,
          contractTypesList: []
        }
      },
      /*
      watch: {
        'contractTypes': function () {
          if (this.contact.contract_types !== undefined) {
            this.updateContractTypesList()
          }
        }
      },*/
      validators: {
        list: function (val) {
          return /^[1-9]+$/.test(val)
        }
      },
      computed: {
        name: function () {
          if (Number.isInteger(this.contact.id)) {
            return this.contact.leader_firstname + ' ' + this.contact.leader_lastname
          } else {
            return 'Contact'
          }
        },
        editionName: function () {
          return (this.job !== null && Number.isInteger(this.job.id)) ? 'Edition' : 'Création'
        }
      },
      methods: {
        edit: function (job) {
          job = this.updateContractTypesList(job)
          this.job = JSON.parse(JSON.stringify(job))
          this.jobUpdate = job
        },
        remove: function (job) {
          job = this.updateContractTypesList(job)
          this.deleteJob(job)
          let that = this
          setTimeout(function () { that.job = null }, 1000)
        },
        create: function () {
          this.job = {}
          this.jobUpdate = null
          this.contractTypesList = []
          this.job = this.updateContractTypesList(this.job)
        },
        cancel: function () {
          this.job = null
          this.jobUpdate = null
          this.contractTypesList = []
        },
        updateContractTypesList: function (job) {
          let list = []
          this.contractTypes.forEach(function (el) {
            el.selected = false
            if (Array.isArray(job.contract_types)) {
              job.contract_types.forEach(function (i) {
                console.log('COMPARE ' + JSON.stringify(i.id + ' VS ' + el.id))
                if (i.id === el.id || JSON.stringify(i.id) === JSON.stringify(el.id)) {
                  if (i.selected === null || i.selected === undefined || i.selected === true) {
                    el.selected = true
                  }
                }
              })
            }
            list.push(el)
          })
          this.contractTypesList = list
          // courseTypesList n'est pas propagé dans la vue...
          job.contract_types_list = list
          return job
        },
        save: function () {
          this.job.contract_types = this.job.contract_types_list
          if (typeof (this.job.start_contract) === 'undefined' || this.job.start_contract === null || this.job.start_contract === '' || this.job.start_contract === 'undefined' || this.job.start_contract === 'Invalid date') {
            this.job.start_contract = ''
          } else {
            this.job.start_contract = moment(this.job.start_contract, 'DD/MM/YYYY').format('DD-MM-YYYY')
          }
          if (typeof (this.job.end_contract) === 'undefined' || this.job.end_contract === null || this.job.end_contract === '' || this.job.end_contract === 'undefined' || this.job.end_contract === 'Invalid date') {
            this.job.end_contract = ''
          } else {
            this.job.end_contract = moment(this.job.end_contract, 'DD/MM/YYYY').format('DD-MM-YYYY')
          }
          if (this.job !== null) {
            if (Number.isInteger(this.job.id) === true) {
              this.editJob(this.jobUpdate, this.job)
            } else {
              this.job.contact_id = this.contact.id
              this.addJob(this.job)
            }
          }

          let contactId = this.contact.id
          let that = this
          setTimeout(function () { that.job = null; that.getJobs(contactId) }, 1000)
        }
      },
      components: { 'date-picker': datePicker, Switch },
      ready () {
        console.log('ready')
        this.$dispatch('preview-data', [])
        let that = this
        this.getContact(this.$route.params.contactId)
        this.getJobs(that.$route.params.contactId)
        this.getContractTypes()
//        this.$http.get('employment').then(function (response) {
//          let contractType = response.json()
//          contractType.forEach(function (element) {
//            that.contract_types[element.id] = element.name
//          })
//        })
      }
    }
</script>



// WEBPACK FOOTER //
// ContactEditEmplois.vue?3ea9aa00